var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { dark: "" } },
    [
      _c(
        "v-app-bar",
        {
          staticClass: "barra",
          attrs: { dark: "", app: "", dense: "", fixed: "" }
        },
        [
          _c("v-app-bar-nav-icon", {
            on: {
              click: function($event) {
                _vm.drawerState = !_vm.drawerState
              }
            }
          }),
          _vm._v(" "),
          _c("v-img", {
            staticClass: "mx-3 mt-3",
            attrs: {
              src: require("@/assets/logo-origo-white.png"),
              "max-height": "80",
              "max-width": "120"
            }
          }),
          _vm._v(" "),
          _c("v-toolbar-title"),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v("\n        Olá " + _vm._s(_vm.account) + "\n        "),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.sair()
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-logout")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDevHml
        ? _c("div", { staticClass: "corner-ribbon" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-navigation-drawer",
        {
          staticClass: "primary",
          style: {
            top: _vm.$vuetify.application.top + "px",
            zIndex: 10,
            width: "300px"
          },
          attrs: { app: "", temporary: "", clipped: "" },
          model: {
            value: _vm.drawerState,
            callback: function($$v) {
              _vm.drawerState = $$v
            },
            expression: "drawerState"
          }
        },
        [_c("menubar")],
        1
      ),
      _vm._v(" "),
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _vm.estornos.length > 0 &&
              _vm.$route.meta.modulo == "Balanço Energético"
                ? _c(
                    "div",
                    { staticClass: "estornos-banner" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "estornos-banner__header",
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              _vm.estornosBannerAberto = !_vm.estornosBannerAberto
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "", color: "#DB8402" }
                            },
                            [_vm._v("mdi-alert-circle-outline")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "estornos-banner__title" },
                            [
                              _vm._v(
                                _vm._s(_vm.estornos.length) +
                                  " referência(s) com estornos pendentes do Balanço Financeiro"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              staticClass: "ml-auto",
                              attrs: { small: "", color: "#DB8402" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.estornosBannerAberto
                                    ? "mdi-chevron-up"
                                    : "mdi-chevron-down"
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-expand-transition", [
                        _vm.estornosBannerAberto
                          ? _c(
                              "div",
                              { staticClass: "estornos-banner__body" },
                              _vm._l(_vm.estornos, function(estorno) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: estorno.referencia,
                                    staticClass: "mr-1 mb-1",
                                    attrs: {
                                      small: "",
                                      outlined: "",
                                      color: "#DB8402"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.irParar(
                                          "visualizar-balanco-referencia-lista",
                                          {
                                            referencia: estorno.referencia,
                                            consorcio: "Todos"
                                          }
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("formataDataMesAno")(
                                            estorno.referencia
                                          )
                                        ) +
                                        " (" +
                                        _vm._s(estorno.contador) +
                                        ")\n                        "
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("flash-message", {
                staticClass: "myCustomClass",
                attrs: { transitionName: "fade-transition" }
              }),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade-transition" } },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("notifications", { attrs: { group: "foo" } }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "360" },
          model: {
            value: _vm.confirmSairDialog,
            callback: function($$v) {
              _vm.confirmSairDialog = $$v
            },
            expression: "confirmSairDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "solis-dialog" },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-icon",
                    { attrs: { left: "", color: "primary", size: "22" } },
                    [_vm._v("mdi-logout")]
                  ),
                  _vm._v("\n                Sair\n            ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [_vm._v("Você deseja sair do sistema?")]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "solis-btn",
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.confirmSairDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "solis-btn",
                      attrs: { color: "primary", depressed: "" },
                      on: { click: _vm.confirmarSair }
                    },
                    [_vm._v("Sair")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420", persistent: "" },
          model: {
            value: _vm.globalConfirmState.visible,
            callback: function($$v) {
              _vm.$set(_vm.globalConfirmState, "visible", $$v)
            },
            expression: "globalConfirmState.visible"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "solis-dialog" },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-icon",
                    { attrs: { left: "", color: "primary", size: "22" } },
                    [_vm._v("mdi-help-circle-outline")]
                  ),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.globalConfirmState.title) +
                      "\n            "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [_vm._v(_vm._s(_vm.globalConfirmState.text))]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "solis-btn",
                      attrs: { text: "" },
                      on: { click: _vm.onConfirmCancel }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "solis-btn",
                      attrs: { color: "primary", depressed: "" },
                      on: { click: _vm.onConfirmOk }
                    },
                    [_vm._v("Confirmar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e8a08d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e8a08d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/app.vue
// module id = null
// module chunks = 